import { nonSeeded } from "../fable_modules/fable-library.3.7.14/Random.js";
import { ofArray, length, item } from "../fable_modules/fable-library.3.7.14/List.js";
import { SoundEffect, Vector2D_op_Subtraction_3C4D5180, Vector2D__get_Magnitude, Game__get_PlayerMapPosition } from "../Model.fs.js";
import { log } from "../Utils.fs.js";
import { contains } from "../fable_modules/fable-library.3.7.14/Set.js";
import { comparePrimitives, max } from "../fable_modules/fable-library.3.7.14/Util.js";
import { playSoundEffectAtVolume } from "../Audio.Platform.fs.js";

const random = nonSeeded();

export function List_random(set$) {
    return item(random.Next1(length(set$)), set$);
}

export function isSoundInArea(game, position) {
    const patternInput = [~(~position.vX), ~(~position.vY)];
    const patternInput_1 = Game__get_PlayerMapPosition(game);
    const playerX = patternInput_1[0] | 0;
    const soundArea = item(patternInput[0], item(patternInput[1], game.Areas)) | 0;
    const playerArea = item(playerX, item(patternInput_1[1], game.Areas)) | 0;
    if ((soundArea === -1) ? true : (playerX === -1)) {
        log("Unable to find area for sound");
        return true;
    }
    else {
        return contains(soundArea, item(playerArea, game.CompositeAreas).ConnectedTo);
    }
}

function calculateVolumeAtPositionRelativeToPlayer(volumeRange, sectorVolumeAdjustment, game, position) {
    const distance = Vector2D__get_Magnitude(Vector2D_op_Subtraction_3C4D5180(game.Camera.Position, position));
    const maximumDistanceAtWhichSoundCanBeHeard = volumeRange;
    if (distance > maximumDistanceAtWhichSoundCanBeHeard) {
        return 0;
    }
    else {
        return (isSoundInArea(game, position) ? ((x) => x) : ((input) => max(comparePrimitives, 0, input - sectorVolumeAdjustment)))((distance <= 1) ? 1 : (1 - (Math.log(distance) / Math.log(maximumDistanceAtWhichSoundCanBeHeard))));
    }
}

export const calculateVolumeOfEnemyRelativeToPlayer = (game) => ((position) => calculateVolumeAtPositionRelativeToPlayer(16, 0.3, game, position));

export const calculateVolumeOfPlayerRelativeToEnemy = (game) => ((position) => calculateVolumeAtPositionRelativeToPlayer(32, 1, game, position));

export function playRandomEnemyDeathSoundEffectAtVolume(game, position) {
    const soundEffect = List_random(ofArray([new SoundEffect(12), new SoundEffect(13)]));
    playSoundEffectAtVolume(calculateVolumeOfEnemyRelativeToPlayer(game)(position), soundEffect);
}

export function playAttackSound(game, position, enemyType) {
    const soundEffect = (enemyType.tag === 0) ? (new SoundEffect(17)) : (new SoundEffect(17));
    playSoundEffectAtVolume(calculateVolumeOfEnemyRelativeToPlayer(game)(position), soundEffect);
}

export function playSoundEffect(game, position, soundEffect) {
    playSoundEffectAtVolume(calculateVolumeOfEnemyRelativeToPlayer(game)(position), soundEffect);
}

